import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import DateInputPicker from 'modules/common/components/DateInputPicker';

const styles = {
  control: (base) => ({
    ...base,
    minHeight: 24,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

const form = {
  type: 'MONTHLY',
  from: moment().startOf('year').format('YYYY-MM-DD'),
  to: moment().endOf('year').format('YYYY-MM-DD'),
};

const getCurrentYear = () => `${new Date().getFullYear()}`;

const getYearsList = (start = getCurrentYear(), endOffset = 50) => {
  let y = [];
  for (let i = start; i > start - endOffset; i -= 1) {
    y = y.concat([
      {
        label: `${i}`,
        value: i,
      },
    ]);
  }
  return y;
};

function DateRangePickerFilter({ onSubmit }) {
  const [formData, setFormData] = useState(form);
  const [toValue, setToValue] = useState(moment().format('YYYY-MM-DD'));
  const [isChanged, setIsChanged] = useState(false);

  const handleChangeSecondPicker = (key) => (e) => {
    if (e.target.value) {
      if (key === 'daily') {
        setToValue(e.target.value);
        setFormData({
          ...formData,
          to: e.target.value,
        });
      } else {
        setToValue(moment(e.target.value).endOf('month').format('YYYY-MM-DD'));
        setFormData({
          ...formData,
          to: moment(e.target.value).endOf('month').format('YYYY-MM-DD'),
        });
      }
      setIsChanged(true);
    }
  };

  const handleChangeInput = (key) => (e) => {
    if (e.target.value) {
      const getTypeParams = (value) => {
        try {
          const paramsObject = {
            DAILY: () => {
              const args = {
                from: e.target.value
                  ? e.target.value
                  : moment().startOf('month').format('YYYY-MM-DD'),
                to: moment(e.target.value).endOf('month').format('YYYY-MM-DD'),
              };
              return args;
            },
            MONTHLY: () => {
              const args = {
                from: e.target.value
                  ? moment(e.target.value).startOf('month').format('YYYY-MM-DD')
                  : moment(e.target.value).startOf('year').format('YYYY-MM-DD'),
                to: toValue
                  ? moment(toValue).endOf('month').format('YYYY-MM-DD')
                  : moment(toValue).endOf('year').format('YYYY-MM-DD'),
              };
              return args;
            },
            YEARLY: () => {
              const args = {
                from: e.target.value
                  ? moment(e.target.value).startOf('year').format('YYYY-MM-DD')
                  : '',
                to: e.target.value
                  ? moment(e.target.value).endOf('year').format('YYYY-MM-DD')
                  : '',
              };
              return args;
            },
          };

          return paramsObject[value] && paramsObject[value]();
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err, 'Something went wrong!');
          return {};
        }
      };

      setFormData({
        ...formData,
        ...getTypeParams(key),
      });
    }
  };

  const handleChangeSelect = (e) => {
    const args = {
      from: e
        ? moment(e.value, 'YYYY-MM-DD').startOf('year').format('YYYY-MM-DD')
        : '',
      to: e
        ? moment(toValue, 'YYYY-MM-DD').endOf('year').format('YYYY-MM-DD')
        : '',
    };

    setFormData({
      ...formData,
      ...args,
    });
  };

  const handleToYearChangeSelect = (e) => {
    setFormData({
      ...formData,
      to: moment(e.value, 'YYYY-MM-DD').endOf('year').format('YYYY-MM-DD'),
    });
    setToValue(
      moment(e.value, 'YYYY-MM-DD').endOf('year').format('YYYY-MM-DD')
    );
    setIsChanged(true);
  };

  const handleOnSubmit = () => {
    onSubmit({ ...formData });
  };

  const filterMapper = {
    DAILY: () => (
      <div className="d-flex justify-content-end align-items-center">
        <div className="d-flex justify-content-end align-items-center">
          <div className="mr-1 d-flex align-self-center  align-items-center">
            <label className="mb-0 mr-1 align-self-center">From</label>
            <div className="w-auto mr-3">
              <DateInputPicker
                onChange={handleChangeInput('DAILY')}
                value={_.get(formData, 'from') || ''}
                maxDate={new Date()}
                className="button-date"

              />
            </div>
            <label className="mb-0 mr-1 align-self-center">To</label>
            <div className="w-auto">
              <DateInputPicker
                onChange={handleChangeSecondPicker('daily')}
                value={isChanged ? toValue : _.get(formData, 'to')}
                className="button-date"
              />
            </div>
          </div>
        </div>
        <div className="ml-1 mt-1">
          <button
            className="btn btn-sm btn-primary cms-bg-color-primary cms-outline-primary "
            onClick={handleOnSubmit}
            type="button"
          >
            Search
          </button>
        </div>
      </div>
    ),
    MONTHLY: () => (
      <div className="d-flex justify-content-end">
        <div className="d-flex justify-content-end">
          <div className="mr-1 d-flex align-self-center">
            <label className="mb-0 mr-1 align-self-center">Month</label>
            <div className="w-auto mr-3">
              <DateInputPicker
                onChange={handleChangeInput('MONTHLY')}
                value={_.get(formData, 'from') || ''}
                showMonthYearPicker
              />
            </div>
            <div className="w-auto">
              <DateInputPicker
                onChange={handleChangeSecondPicker('monthly')}
                value={
                  isChanged
                    ? toValue
                    : moment().endOf('year').format('YYYY-MM-DD')
                }
                showMonthYearPicker
              />
            </div>
          </div>
        </div>
        <div className="ml-1 mt-1">
          <button
            className="btn btn-sm btn-primary cms-bg-color-primary cms-outline-primary "
            onClick={handleOnSubmit}
            type="button"
          >
            Search
          </button>
        </div>
      </div>
    ),
    YEARLY: () => (
      <div className="d-flex justify-content-end align-items-center">
        <div className="d-flex justify-content-end">
          <div className="mr-1 d-flex align-self-center">
            <label className="label-transaction-card mb-0 mr-1 align-self-center">
              From
            </label>
            <div className="w-auto mr-3">
              <div style={{ width: 200 }}>
                <Select
                  styles={styles}
                  placeholder="Select Year"
                  value={
                    getYearsList().filter(
                      (item) =>
                        `${item.value}` ===
                        `${_.get(formData, 'from')
                          ? moment(_.get(formData, 'from')).format('YYYY')
                          : ''
                        }`
                    )[0]
                  }
                  options={getYearsList()}
                  onChange={handleChangeSelect}
                />
              </div>
            </div>
          </div>
          <div className="mr-1 d-flex align-self-center">
            <label className="label-transaction-card mb-0 mr-1 align-self-center">
              To
            </label>
            <div className="w-auto">
              <div style={{ width: 200 }}>
                <Select
                  styles={styles}
                  placeholder="Select Year"
                  value={
                    getYearsList().filter(
                      (item) =>
                        `${item.value}` ===
                        `${_.get(formData, 'to')
                          ? moment(_.get(formData, 'to')).format('YYYY')
                          : ''
                        }`
                    )[0]
                  }
                  options={getYearsList()}
                  onChange={handleToYearChangeSelect}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="ml-1">
          <button
            className="btn btn-sm btn-primary cms-bg-color-primary cms-outline-primary "
            onClick={handleOnSubmit}
            type="button"
          >
            Search
          </button>
        </div>
      </div>
    ),
  };

  const setType = (type) => (e) => {
    e.preventDefault();
    setIsChanged(false);

    const getTypeParams = (value) => {
      try {
        const paramsObject = {
          DAILY: () => {
            const args = {
              type: 'DAILY',
              from: moment().subtract(1, 'M').format('YYYY-MM-DD'),
              to: moment().format('YYYY-MM-DD'),
            };
            return args;
          },
          MONTHLY: () => {
            const args = {
              type: 'MONTHLY',
              from: moment().startOf('year').format('YYYY-MM-DD'),
              to: moment().endOf('year').format('YYYY-MM-DD'),
            };
            return args;
          },
          YEARLY: () => {
            const args = {
              type: 'YEARLY',
              from: moment().startOf('year').format('YYYY-MM-DD'),
              to: moment().endOf('year').format('YYYY-MM-DD'),
            };
            return args;
          },
        };

        return paramsObject[value] && paramsObject[value]();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err, 'Something went wrong!');
        return {};
      }
    };

    setFormData({
      ...formData,
      ...getTypeParams(type),
    });

    onSubmit({
      ...formData,
      ...getTypeParams(type),
    });
  };

  const { type } = formData;

  return (
    <>
      <div className="total-transaction-filer d-flex justify-content-between">
        <ul className="nav">
          <li className="nav-item">
            <a
              className={`nav-link${type === 'DAILY' ? ' active' : ''}`}
              href="/"
              onClick={setType('DAILY')}
            >
              Daily
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link${type === 'MONTHLY' ? ' active' : ''}`}
              href="/"
              onClick={setType('MONTHLY')}
            >
              Monthly
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link${type === 'YEARLY' ? ' active' : ''}`}
              href="/"
              onClick={setType('YEARLY')}
            >
              Yearly
            </a>
          </li>
        </ul>
      </div>
      {filterMapper[type] && filterMapper[type]()}
    </>
  );
}

DateRangePickerFilter.propTypes = {
  onSubmit: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(DateRangePickerFilter);
